export enum ExamLogType {
	AuthenticationInformation = 0,
	AuthenticationWarning = 1,
	CandidateExamInformation = 2,
	CandidateBreakInformation = 3,
	CandidateNavigatedWarning = 4,
	CandidateLocked = 5,
	CandidateUnlocked = 6
}
